import React from "react";
import Pagination from "../components/blogs/Pagination";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import BlogCardCreadores from "../components/blogs/BlogCardCreadores"

export default function BlogCreadores() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        HeaderTitle="Ayuda para Creadores"
        Parent="Ayuda"
        PageTitle="Guias de Uso"
      />
      <BlogCardCreadores />
      <Pagination hasBg />
      <Footer />
    </Layout>
  );
}
